import React from 'react'
import Head from 'next/head'
import {useRouter} from 'next/router'

import {createLog} from '@util/logs'
import {useTranslation} from '@lib/intl/useTranslations'
import {getMessages} from '@lib/intl/intl'
import useNavigation from '@hook/useNavigation'

import PageConfig from '@component/layouts/PageConfig/PageConfig'
import LeaderboardCarousel from '@feature/leaderboard/components/LeaderboardCarousel/LeaderboardCarousel'

import LeaderboardTabNavigation, {
    LeaderboardTab,
} from '@feature/leaderboard/components/LeaderboardTabNavigation/LeaderboardTabNavigation'

import LeaderboardScreenMain from '@feature/leaderboard/pages/ScreenMain/LeaderboardScreenMain'
import LeaderboardScreenCopyLeader from '@feature/leaderboard/pages/ScreenCopyLeader/LeaderboardScreenCopyLeader'
import LeaderboardScreenLeague from '@feature/leaderboard/pages/ScreenLeague/LeaderboardScreenLeague'
import ScreenLeagueList from '@feature/leaderboard/pages/ScreenPreviousLeague/ScreenLeagueList'
import ProNoticeBottomSheet from '@feature/leaderboard/components/ProNoticeBottomSheet/ProNoticeBottomSheet'

const LeaderboardPage = () => {
    const t = useTranslation()
    const {query, isReady} = useRouter()
    const tab = (query?.tab as LeaderboardTab) || 'main'

    const {goLeaderboard} = useNavigation()
    const onChangeTab = (tab: LeaderboardTab) => {
        createLog('event', 'leaderboard_page_tab', {page: tab})
        goLeaderboard(tab)
    }

    return (
        <PageConfig enableFloatingNavigation={true} navTheme={'dark'} pageName={'home'}>
            <Head>
                <title>{t('newLeaderboard.layout.nav.menu.mainLeaderboard')}</title>
            </Head>
            <div className={'layout-full_desktop overflow-hidden min-h-screen dark:bg-bg_dark_background'}>
                <LeaderboardCarousel />
                <div
                    className={
                        'max-w-1366px mx-auto w-full page_padding_default_x page_padding_default_bottom pt-[30px] sm:pt-[10px]'
                    }>
                    <LeaderboardTabNavigation activeTab={tab || 'main'} onChangeActiveTab={onChangeTab} />

                    {tab === 'main' && <LeaderboardScreenMain />}
                    {tab === 'copyleader' && <LeaderboardScreenCopyLeader />}
                    {tab === 'league' && <LeaderboardScreenLeague />}
                    {tab === 'league-all' && <ScreenLeagueList />}
                </div>
            </div>
            <ProNoticeBottomSheet />
        </PageConfig>
    )
}

export const getStaticProps = async ctx => {
    return {
        props: {
            messages: await getMessages(ctx.locale || 'en'),
        },
    }
}

export default LeaderboardPage
